import React from 'react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { getPartnerUserColumn, getAllPartnerUser, save, deletePartner } from './actions';

class PartnerList extends React.Component {
    constructor() {
        super();
        this.state = {
            list: [],
            showModal: false,
            editMode: false,
            form: {},
        };
        this.getPartnerUserColumn = getPartnerUserColumn.bind(this);
        this.getAllPartnerUser = getAllPartnerUser.bind(this);
        this.save = save.bind(this);
        this.deletePartner = deletePartner.bind(this);
    }

    componentWillMount() {
        this.getAllPartnerUser();
    }

    changeFormValue(attribute, value) {
        this.setState({
            form: {
                ...this.state.form,
                [attribute]: value,
            },
        });
    }


    render() {
        const filterMethod = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null && typeof row[id] === 'string') {
                const returnValue = row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true;
                return returnValue;
            }
        };
        const { form } = this.state;
        console.log(this.props, "propp")
        // if (this.props.user.loggedInUser.Partner_Authority__c !== 'Approver') {
        //     return <Redirect to="/portal" />;
        // }
        return (
            <div className="row">
                <div className="card list">
                    <p style={{ textAlign: 'center' }}>
                        {this.state.loading ? <i className="fa fa-2x fa-spinner fa-spin" /> : null}
                    </p>
                    <div className="row">
                        <div className="col-lg-6 col-xs-12">
                            <h3>Partner List</h3>
                        </div>
                        <div className="col-lg-6 col-xs-12 pull-right" style={{ textAlign: 'right' }}>
                            <button className="btn btn-primary btn-fill" onClick={() => this.setState({ showModal: true, editMode: false, form: {} })}>
                                <i className="fa fa-file" /> New Partner
                            </button>
                        </div>
                    </div>
                    <ReactTable
                        data={this.state.list}
                        columns={this.getPartnerUserColumn()}
                        defaultFilterMethod={filterMethod}
                        filterable
                        sortable
                        getTdProps={() => ({
                            style: {
                                border: '1px solid #eee',
                                padding: 10,
                                fontSize: 14,
                            },
                        })}
                        defaultPageSize={10}
                    />
                </div>
                <div className="modal modal-backdrop" tabIndex="-2" role="dialog" style={{ display: this.state.showModal ? 'block' : 'none' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    onClick={() => this.setState({ showModal: false, form: {}, editMode: false })}
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 className="modal-title">{this.state.editMode ? 'Edit a' : 'Create a new'} partner</h4>
                            </div>
                            <div className="modal-body">
                                <form id="partner-form" onSubmit={this.save}>
                                    <p style={{ textAlign: 'center' }}>
                                        {this.state.loading ? <i className="fa fa-2x fa-spinner fa-spin" /> : null}
                                    </p>
                                    <div className="form-group">
                                        <p>Name</p>
                                        <input
                                            className="form-control"
                                            value={form.Name || ''}
                                            onChange={e => this.changeFormValue('Name', e.target.value)}
                                            type="text"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <p>Email</p>
                                        <input
                                            className="form-control"
                                            value={form.Email || ''}
                                            onChange={e => this.changeFormValue('Email', e.target.value)}
                                            type="email"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <p>Home Phone</p>
                                        <input
                                            className="form-control"
                                            value={form.HomePhone || ''}
                                            onChange={e => this.changeFormValue('HomePhone', e.target.value)}
                                            type="tel"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <p>Mobile Phone</p>
                                        <input
                                            className="form-control"
                                            value={form.MobilePhone || ''}
                                            onChange={e => this.changeFormValue('MobilePhone', e.target.value)}
                                            type="tel"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <p>Password</p>
                                        <input
                                            className="form-control"
                                            id="partner-password"
                                            title="Min. 8 characters including special characters"
                                            placeholder="Min. 8 characters including special characters"
                                            value={form.Password__c || ''}
                                            onChange={e => this.changeFormValue('Password__c', e.target.value)}
                                            type="password"
                                            required={!this.state.editMode}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <p>Active ?</p>
                                        <select
                                            value={form.Active__c === 'true' || form.Active__c === true ? 'true' : 'false'}
                                            className="form-control"
                                            onChange={e => this.changeFormValue('Active__c', e.target.value)}
                                            required
                                        >
                                            {/* <option value="" /> */}
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <p>Partner Authority</p>
                                        <p style={{ fontSize: 15 }}>Verifier</p>
                                        {/* <select value={form.Partner_Authority__c || ''} className="form-control" onChange={e => this.changeFormValue('Partner_Authority__c', e.target.value)}>
                                        <option value="" />
                                        <option value="Approver">Approver</option>
                                        <option value="Verifier">Verifier</option>
                                    </select> */}
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    onClick={() => this.setState({ showModal: false, form: {}, editMode: false })}
                                    className="btn btn-default"
                                >
                                    Close
                                </button>
                                <button
                                    form="partner-form"
                                    type="submit"
                                    className="btn btn-success btn-fill"
                                >
                                    <i className="fa fa-save" /> {this.state.editMode ? 'Update' : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PartnerList.propTypes = {
    user: PropTypes.object.isRequired,

};

PartnerList.defaultProps = {

};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});
export default connect(mapStateToProps, mapDispatchToProps)(PartnerList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/UserManagement/PartnerList.js
// module id = 1000
// module chunks = 0